import config from '@/config';
import { api } from './api';
import { fetchMachineToken } from '@/utils/fetch';
import { setMachineToken } from '../state/authSlice';
import { RootState } from '../store';
import { isExpired } from '@/utils/token';

const IDENTITY_API = config.identityApi;

export const identityApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMachineToken: build.query<string | null, void>({
      queryFn: async (arg, { getState, dispatch }) => {
        const state = getState() as RootState;
        if (state.auth.machineToken && !isExpired(state.auth.machineToken))
          return { data: state.auth.machineToken };
        const token = await fetchMachineToken();
        if (token) dispatch(setMachineToken(token));
        return {
          data: token,
        };
      },
    }),
  }),
});

export const { useGetMachineTokenQuery } = identityApi;
